import { Navigate, type RouteObject } from 'react-router';

/**
 * The administration area (014 FR-016). Mounted at `/admin` — `/admin/accounts`, never
 * `/accounts`, because `/account` (the holder's own screen) and `/accounts` differ by one character
 * and one of them is admin-only. The admin guard sits on the mount in `app.routes.tsx`, so a screen
 * added here later cannot forget it — same construction as the shell's signed-in guard.
 */
export const routes: RouteObject[] = [
  { index: true, element: <Navigate to="accounts" replace /> },
  { path: 'accounts', lazy: async () => ({ Component: (await import('./accounts-page')).default }) },
];
